import { colors } from '@mui/material';

const appDarkGrey = '#7D7D7D';
const appGreen = '#27AE60';
const appBlue = '#0068FF';

export const palette = {
    appDarkGrey,
    appBlue,
    appGreen,
    primary: {
        main: '#161616',
        light: '#26dde6',
        contrastText: '#e5e7eb',
    },
    secondary: {
        main: '#ff5c38',
    },
    text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600],
        link: colors.blue[600],
    },
    background: {
        default: 'var(--color-background)',
    },
    chip: {
        open: '#FF5141',
        inProgress: '#0068FF',
        onHold: '#F2994A',
        done: '#27AE60',
    },
    bookingChip: {
        started: '#0068ff',
        not_started: '#ff5141',
        finished: '#f2994a',
    },
    border: {
        main: 'rgba(51, 51, 51, 1)',
        dark: 'rgba(51, 51, 51, 1)',
        light: 'rgba(51, 51, 51, 0.5)',
    },
};
